module.exports = __webpack_public_path__ + "img/symbol_5.796a178f.png";